<template>
  <div>
    <div
      v-if="records?.length"
      class="column q-gutter-sm">
      <div
        v-for="record in records"
        :key="`${record.model}:${record.id}`"
        class="row items-center q-gutter-sm">
        <StatusPill
          color="positive"
          :label="modelLabel(record.model)" />
        <CrudPreview
          :model-name="record.model"
          :model-id="record.id" />
      </div>
    </div>
    <div
      v-else
      class="text-caption text-grey-6">
      {{ t('records.empty') }}
      <template v-if="showHint"> — {{ t('records.emptyHint') }}</template>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useCompositeI18n } from 'src/CrudManager/Core/composables/useCompositeI18n'
import StatusPill from 'src/CrudManager/Core/composites/Ui/StatusPill/StatusPill.vue'
import type { GeneratedRecord } from '../types'

/**
 * Records the pipeline created, each as a CrudPreview: one click opens the
 * record preview, its edit button (or ctrl+click) jumps to the full editor.
 */
withDefaults(defineProps<{ records: GeneratedRecord[] | undefined; showHint?: boolean }>(), {
  showHint: false,
})

const { t } = useCompositeI18n('core.AiDocumentProcessor')

const modelLabel = (modelType: string): string => {
  const key = `records.models.${modelType}`
  const label = t(key)
  return label === `core.AiDocumentProcessor.${key}` ? modelType : label
}
</script>
